import {RESOLVER_DEPTH_CAP, resolveRecipeFromChain} from "../RecipeResolverCore.js";
import {GetBuiltInRecipe, builtInRecipes} from "../MaterialFuncRegistry.js";
import type {MaterialRecipe} from "../@MaterialTypes.js";

/** Resolve a built-in recipe to a flat ResolvedRecipe, WALKING any `baseRecipeID` chain through
 *  the built-in catalogue — mirroring the runtime resolver (`ProcMatAccessors.ResolveRecipe`),
 *  which is what actually assembles shaders in the app.
 *
 *  WHY THIS MATTERS: the starfield recipe is a DERIVED built-in (it extends `starfield_full` and
 *  disables layers).  A single-element `resolveRecipeFromChain([recipe])` would NOT walk the base,
 *  so tests would resolve only the derived shell (no base layers).  Most built-ins are ROOTS
 *  (dirt/cobble/etc.), so for them this is unchanged — the chain is `[recipe]`. */
export function ResolveBuiltInRecipe(id: string) {
	const chain: MaterialRecipe[] = [];
	const visited = new Set<string>();
	let cur = GetBuiltInRecipe(id);
	if (!cur) throw new Error(`Built-in recipe "${id}" not found`);
	while (cur != null) {
		if (visited.has(cur.id)) throw new Error(`Built-in recipe base-chain cycle detected: ${[...visited, cur.id].join(" -> ")}`);
		visited.add(cur.id);
		if (visited.size > RESOLVER_DEPTH_CAP) throw new Error(`Built-in recipe base-chain depth cap (${RESOLVER_DEPTH_CAP}) exceeded: ${[...visited].join(" -> ")}`);
		chain.unshift(cur);
		if (cur.baseRecipeID == null) break;
		cur = builtInRecipes.get(cur.baseRecipeID);
	}
	return resolveRecipeFromChain(chain);
}